import { SimpleAlert, StandardAlert } from '@cimplico/components';

type ErrorAlertProps = {
    message: string;
};

function ErrorAlert({ message }: ErrorAlertProps): JSX.Element {
    const hasMultiple = message.split('\n').length > 1;

    if (!hasMultiple) {
        return <SimpleAlert title={message} type="error" />;
    }

    const start = message.split(':')[0];
    const items = message.split(':').slice(1).join(' ').trim();

    return (
        <StandardAlert title={start} type="error" description={items.split('\n')}>
            <></>
        </StandardAlert>
    );
}

export default ErrorAlert;
